import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Icon, Button, Input, message, List } from 'utils/ui';
import { sendResetEmail } from "../api_calls/user";
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';


const headerFontSize = "14pt";

@observer(["UserStore"])
class ForgotPasswordButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            hashPass: "",
            family: "",
            forgotModalIsOpen: false,
        };
        this.closeForgotModal = this.closeForgotModal.bind(this);
        this.submitForgot = this.submitForgot.bind(this);
    }

    submitForgot() {
        this.setState({ forgotModalIsOpen: false });
        sendResetEmail(this.state.forgotEmail).then((res) => {
            console.info(res);
        })

    }

    closeForgotModal() {
        this.setState({ forgotModalIsOpen: false });
    }

    render() {
        return (
            <div>
                <ModalShell
                    isOpen={this.state.forgotModalIsOpen}
                    onRequestClose={this.closeForgotModal}
                    contentLabel="Forgot Modal"
                    className="register-modal"
                    overlayClassName="register-modal-overlay"
                    maxWidth={600}>
                    <ModalBody title="Reset Password" subtitle="Enter your email and we will send a reset link" className="ui-modal-surface-compact">
                        <div className="AppFont ui-modal-stack" style={{ fontSize: headerFontSize, color: "#222", textAlign: "center" }}>
                            <label className="ui-form-label" style={{ textAlign: "left" }}>Email</label>
                            <Input id="password-forgot" style={{ textAlign: "center" }} type="email" onChange={(e) => { this.setState({ forgotEmail: e.target.value }) }} />
                            <div className="ui-modal-actions">
                                <Button className="btn-submit ui-btn-success" id="submitBtn-forgot" onClick={this.submitForgot} size="large" >Send Reset Link To My Email</Button>
                            </div>
                        </div>
                    </ModalBody>
                </ModalShell>
                <a
                    onClick={(e) => { this.setState({ forgotModalIsOpen: true }) }}
                    style={{ fontSize: "7pt", padding: "5px", borderRadius: "40px", backgroundColor: "rgba(0,0,0,0.3)", color: "white", fontWeight: "bold" }}>Forgot password?</a>
            </div>
        );
    }
}

export default ForgotPasswordButton;